import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    components: {
        globals,
    },

    methods: {
        async getVendorList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_API + "/manufacturing/vendors/list", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getPrimaryVendorList(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.SCM_API + `/manufacturing/vendors/get?id=`+id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getPermissionList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response =await this.$http.post(globals.CRM_SALES_URL +`/team/list`,params);
                    
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = sessionStorage.getItem("error")
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getPermissionData(id) {
            try {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.get("call_report/permission?id="+id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            }
            catch(error) {
                this.warning_msg = error.response.data.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async savePermissionData(params) {
            try {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.post("call_report/permission/update",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            }
            catch(error) {
                this.warning_msg = error.response.data.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async validateFutureDate(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("integration_apis/call_report/date_time_validation", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async searchCustomer(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post("/shadow_users/search", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async searchCompanies(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post("/shadow_companies/search", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async searchEmployee(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post("/shadow_employees/search", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async storeCallReport(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/call_report/mobile/add", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch(error) {
                    reject(error.response.data.reason);
                    // this.warning_msg = error.response.data.reason
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    //     this.$modal.hide("loader_modal");
                    // }, 3000);
                }  
            })
        },
        async getEmployees(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post("/employees/get_employees", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async searchBrancheDeparment(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post("/shadow_companies/get_branches", params)
                if (response.data.status_id == 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
		async getCallReportById(params) {
			return new Promise(async (resolve, reject) => {
				let response = await this.$http.get("/call_report/get?id="+params)
				if (response.data.status_id == 1) {
					resolve(response.data)
				} else {
					reject(response.data)
				}
			})
        },
        async copyCallReportById(params) {
			return new Promise(async (resolve, reject) => {
				let response = await this.$http.get(`/call_report/copy/get?id=${params.id}&source=${params.source}&category=${params.category}`)
				if (response.data.status_id == 1) {
					resolve(response.data)
				} else {
					reject(response.data)
				}
			})
		},
		async getDraftCallReportById(params) {
			return new Promise(async (resolve, reject) => {
				let response = await this.$http.get("/call_report/get_draft_by_id?id="+params)
				if (response.data.status_id == 1) {
					resolve(response.data)
				} else {
					reject(response.data)
				}
			})
		},
		async deleteDraftCallReportById(params) {
			return new Promise(async (resolve, reject) => {
				let response = await this.$http.get("/call_report/drafts/delete?id="+params)
				if (response.data.status_id == 1) {
					resolve(response.data)
				} else {
					reject(response.data)
				}
			})
        },
        async getCallReportsList(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/call_report/list_view", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err){
                    reject(err.response.data.reason)
                }
            })
        },
        async getSubsidiary(id,params) {
            try {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.get(globals.AUTH_SERVICE +`/organization/subsidiary/settings/${id}?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}&product_id=${params.product_id}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            }
            catch(error) {
                this.warning_msg = sessionStorage.getItem("error")
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.$modal.hide("loader_modal");
                }, 3000);
            }
        },
        async getLocalTime() {
            try {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.get(globals.CRM_API +"/organisation_settings/datetime/local")
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            }
            catch(error) {
                this.warning_msg = sessionStorage.getItem("error")
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.$modal.hide("loader_modal");
                }, 3000);
            }
        },
        async getUTCTime(params){
            try {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.post(globals.CRM_API +"/integration_apis/datetime/utc",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            }
            catch(error) {
                this.warning_msg = sessionStorage.getItem("error")
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.$modal.hide("loader_modal");
                }, 3000);
            }
        }
    },
    created() {
        const dict = {
            custom: {
                title_name: {
                    required: () => 'Title Name is Required',
                    regex: () => 'Title Name Format is Invalid'
                }
            }
        }
        this.$validator.localize('en', dict)
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/callreport.js